import React  from 'react';
import { NavLink } from "react-router-dom";
import logo from '../assets/images/logo.png';
const Navbar = ({classNav}) =>{

    return(
        <header className={`cassandra-nav ${classNav}`}>
            <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        <a className="navbar-brand" href="/home">  <img className="img-fluid" src={logo} alt="cassandra logo" /></a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"   aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" >
                            <span className="navbar-toggler-icon">
                                <svg style={{width:20, height:20}}
                                xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"
                                version="1.1" x="0px" y="0px" viewBox="0 0 512 512"
                                 space="preserve">
                                <g fill="#fff">
                                    <path  d="M492,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,236,492,236z"/>
                                    <path  d="M492,76H20C8.954,76,0,84.954,0,96s8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,76,492,76z"/>
                                    <path  d="M492,396H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20    C512,404.954,503.046,396,492,396z"/>
                                </g>
                                 </svg>
                            </span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item"><NavLink to={"/home"} className="nav-link" activeClassName="active">الرئيسية</NavLink></li>
                                <li className="nav-item"><NavLink to={"/about"} className="nav-link"  activeClassName="active" >من نحن</NavLink></li>
                                <li className="nav-item"><a href="#contactModel" className="nav-link" data-toggle="modal"  >تواصل معنا</a></li>
                                <li className="nav-item"><a href="#loginModel" className="nav-link"  data-toggle="modal"  >حسابى</a> </li>
                                 
                                <li className="nav-item">

                                <NavLink to={"/search"} className="nav-link">
                                    <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' style={{width:20, height:20}}>
                                        <g fill-rule="evenodd" fill="rgb(240, 240, 249)">
                                            <path d="M14.215,14.169 C12.649,15.735 10.567,16.598 8.352,16.598 C6.138,16.598 4.056,15.735 2.490,14.169 C0.924,12.604 0.062,10.522 0.062,8.307 C0.062,6.093 0.924,4.011 2.490,2.445 C4.056,0.879 6.138,0.016 8.352,0.016 C10.567,0.016 12.649,0.879 14.215,2.445 C15.780,4.011 16.643,6.093 16.643,8.307 C16.643,10.522 15.780,12.604 14.215,14.169 ZM8.352,1.598 C4.653,1.598 1.644,4.608 1.644,8.307 C1.644,12.007 4.653,15.016 8.352,15.016 C12.052,15.016 15.061,12.007 15.061,8.307 C15.061,4.608 12.052,1.598 8.352,1.598 Z"/>
                                            <path d="M19.411,18.247 L14.212,13.047 C13.902,12.739 13.402,12.739 13.093,13.047 C12.784,13.357 12.784,13.857 13.093,14.167 L18.293,19.366 C18.447,19.520 18.649,19.597 18.852,19.597 C19.054,19.597 19.257,19.520 19.411,19.366 C19.720,19.057 19.720,18.556 19.411,18.247 Z" />
                                        </g>
                                    </svg>
                                
                                </NavLink>
                            
                            </li>

                            </ul>
                        
                        </div> 


                    </div>
                 
                            
                </nav>
            </div>

           
            
      </header>
        
    );

};

export default Navbar;